// src/components/VideoSection.js

import React from "react";
import { Link } from "react-router-dom";
import "./styles.css";
import useScrollReveal from "../../../../assets/hooks/useScrollReveal/useScrollReveal";
// Dữ liệu video mẫu từ YouTube search
const videoData = [
  {
    title: "WEBINAR #6 KINH NGHIỆM TRIỂN KHAI LĨNH VỰC CƠ ĐIỆN M&E",
    channel: "FastWork Việt Nam",
    url: "http://www.youtube.com/watch?v=MHPoX-yLvMY",
    length: "1:23:12",
    views: "331",
  },
  {
    title: "Tài liệu thiết kế thi công và giám sát cơ điện công trình",
    channel: "VNK EDU",
    url: "http://www.youtube.com/watch?v=n14r23tkx38",
    length: "6:35",
    views: "1.253",
  },
  {
    title: "BÀI 41 QUẢN LÝ DỰ ÁN VÀ TỔ CHỨC THI CÔNG M&E",
    channel: "Ks. Nguyễn Đức Tiến Luyện - Thi Công Cơ Điện",
    url: "http://www.youtube.com/watch?v=g92r767VcH4",
    length: "19:19",
    views: "562",
  },
  {
    title:
      "[VNK] Khóa kỹ sư M&E chuyên nghiệp - 5 bước giám sát thi công hệ thống điện",
    channel: "Vật Liệu Điện",
    url: "http://www.youtube.com/watch?v=xFz2IrRNaeg",
    length: "5:26",
    views: "17.575",
  },
  {
    title: "BÀI 40. QUẢN LÝ DỰ ÁN VÀ TỔ CHỨC THI CÔNG M&E",
    channel: "Ks. Nguyễn Đức Tiến Luyện - Thi Công Cơ Điện",
    url: "http://www.youtube.com/watch?v=LlYcvrS7Igo",
    length: "15:58",
    views: "943",
  },
];

const VideoSection = () => {
  const getRevealClass = (isVisible) =>
    `service-card scroll-reveal-item ${isVisible ? "is-visible" : ""}`;
  return (
    <section className="video-section">
      <h3 className="video__subtitle">VIDEO DỰ ÁN VÀ KINH NGHIỆM THI CÔNG</h3>

      <div className="video__grid">
        {videoData.map((video, index) => {
          const [cardRef, isCardVisible] = useScrollReveal({ threshold: 0.5 });
          return (
            <div
              key={index}
              ref={cardRef}
              className={`${getRevealClass(isCardVisible)} video__card`}
            >
              {}
              <div className="video__thumbnail-wrapper">
                {}
                {}
                <img
                  src={`https://img.youtube.com/vi/${
                    video.url.split("v=")[1]
                  }/hqdefault.jpg`}
                  alt={video.title}
                  className="video__thumbnail"
                  // Tạo link để người dùng click vào xem video
                  onClick={() => window.open(video.url, "_blank")}
                />
                <span className="video__length">{video.length}</span>
              </div>

              {}
              <div className="video__info">
                <h4 className="video__title">
                  {}
                  <a href={video.url} target="_blank" rel="noopener noreferrer">
                    {video.title}
                  </a>
                </h4>
                <p className="video__channel">{video.channel}</p>
                <p className="video__views-date">{video.views} lượt xem</p>
              </div>
            </div>
          );
        })}
      </div>

      {}
      <div className="video__cta-wrapper">
        <Link to="/kenh-youtube" className="video__view-all-btn">
          XEM THÊM
        </Link>
      </div>
    </section>
  );
};

export default VideoSection;
